import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './hooks/useAuth';
import Layout from './components/Layout';
import LoginPage from './app/login';
import DashboardPage from './app/dashboard';
import SearchPage from './app/search';
import ParcelDetailPage from './app/parcels/[id]';
import OwnerDetailPage from './app/owners/[id]';
import AnalyticsPage from './app/analytics';
import AdminPage from './app/admin';
import ApiDocsPage from './app/api-docs';
import ScrapePage from './app/scrape';
import ReportsPage from './app/reports';
import LoadingScreen from './components/LoadingScreen';
import { RequireAuth } from './components/RequireAuth';

function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/" element={
          <RequireAuth>
            <Layout />
          </RequireAuth>
        }>
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<DashboardPage />} />
          <Route path="search" element={<SearchPage />} />
          <Route path="parcels/:id" element={<ParcelDetailPage />} />
          <Route path="owners/:id" element={<OwnerDetailPage />} />
          <Route path="analytics" element={<AnalyticsPage />} />
          <Route path="admin" element={<AdminPage />} />
          <Route path="scrape" element={<ScrapePage />} />
          <Route path="reports" element={<ReportsPage />} />
          <Route path="api-docs" element={<ApiDocsPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
      <LoadingScreen />
    </AuthProvider>
  );
}

export default App;
